import { DEFAULT_LATEST, THIS_MONTH, TODAY } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { DateBaseValidatorOptions } from 'forms/shared/validators/base/date/types';
import { getSafeDateTime, isSafeDateLater, setToStartOfMonth } from 'helpers/date';
import { SafeDateTime } from 'helpers/types';
import { SubstanceAlcoholNegativeItemModel } from '../types';

const substanceAlcoholNegativeItemValidator: ValidateJSModel<SubstanceAlcoholNegativeItemModel> = {
  Occurred: (value, attributes, attributeName, options) => {
    const toDate = getSafeDateTime(attributes?.Used?.to);
    const fromDate = setToStartOfMonth(getSafeDateTime(attributes?.Used?.from));
    const beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH.minus({ years: 7 }));
    const useDuration = !(options?.formType && options?.formType === 'SF86') && isSafeDateLater(beyondRequired, fromDate);

    const dateLimits: DateBaseValidatorOptions = {
      earliest: useDuration ? beyondRequired.datetime : fromDate.datetime,
      latest: toDate.valid ? toDate.datetime : DEFAULT_LATEST,
      tooEarly: useDuration ? 'error.beforeDuration' : 'error.alcohol.negativeImpact.occurred.error.tooEarly',
      tooLate: 'error.alcohol.negativeImpact.occurred.error.tooLate',
      requireYear: false,
    };

    return {
      presence: true,
      date: { requireDay: false, ...dateLimits },
    };
  },
  Circumstances: { presence: true, hasValue: true },
  NegativeImpact: { presence: true, hasValue: true },
  Used: (value, attributes, attributeName, options) => {
    const applicantEighteenthBirthdate: SafeDateTime | undefined = options?.applicantBirthdate && getSafeDateTime(getSafeDateTime(options?.applicantBirthdate)?.datetime?.plus({ years: 18 }));
    let beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH.minus({ years: 7 }));

    if (options?.formType && options?.formType === 'SF86' && !value?.present
      && applicantEighteenthBirthdate?.valid && isSafeDateLater(beyondRequired, applicantEighteenthBirthdate)) {
      beyondRequired = setToStartOfMonth(applicantEighteenthBirthdate);
    }

    const useDuration = !value?.present && isSafeDateLater(beyondRequired, getSafeDateTime(value?.to));

    return {
      presence: true,
      daterange: {
        requireYear: false,
        earliest: useDuration ? setToStartOfMonth(beyondRequired).datetime : setToStartOfMonth(options?.applicantBirthdate),
        tooEarly: useDuration ? 'error.beforeDuration' : 'error.applicantMin',
        latest: DEFAULT_LATEST
      },
    };
  },
  Comments: {},
};

export default substanceAlcoholNegativeItemValidator;
